/**
 * file_name.js
 *
 * @경로 :
 * @목적 :
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import MixinBuilder from 'canvas/base/dev/scripts/MixinBuilder';
let mix = (superclass) => new MixinBuilder(superclass);

import B_Define         from 'canvas/base/dev/util/B_Define';
import B_Real from 'canvas/base/dev/child/base/B_Real';
import B_ChildTool from 'canvas/base/dev/child/base/B_ChildTool';
import B_Shape from 'canvas/base/dev/child/shape/B_Shape';
import B_ShapeHeader from 'canvas/base/dev/child/shape/B_ShapeHeader';

const B_HeaderTryCount = (function(){

	class B_HeaderTryCount extends mix(B_Real).with(B_ChildTool, B_Shape, B_ShapeHeader) {

		constructor(inputJson) {
			super(inputJson);

			// [S] 'width'에 따른 반응형으로 제작
			this._WIDTH = inputJson.w;
			this._HEIGHT = this._WIDTH / 4;
			this._FONT_SIZE = this._WIDTH / 10;
			this._ICON_WIDTH = this._WIDTH / 2.5;
			this._ICON_HEIGHT = this._ICON_WIDTH / 4;

			// [S] shape & icon & text 생성
			this._fitShape( this._WIDTH, this._HEIGHT, B_Define.SHAPE_BG );
			this[B_Define.TRY_COUNT_ICON_ID] = this._getIcon( this._WIDTH, this._HEIGHT, this._ICON_WIDTH, this._ICON_HEIGHT, B_Define.TRY_COUNT_ICON_RES );
			this[B_Define.TRY_COUNT_TEXT_ID] = this._getText( this._WIDTH, this._HEIGHT, this._FONT_SIZE, B_Define.TRY_COUNT_INIT_VALUE );

			// [#] max 설정
			this._maxCount = inputJson.max;
			this._restCount = inputJson.max;
			this._setCount(0);

		}

		// @DES :: maxCount {num}
		get maxCount() { return this._maxCount; }
		// set max(m) {}

		// @DES :: restCount {num}
		get restCount() { return this._restCount; }
		// set index(i) {}

		// [F] protected

		/**
		 * [Function :: _setCount]
		 *
		 * @DES :: Text 객체 설정하기
		 * @IP1 :: numCount {num}
		 * @O.P :: null
		 * @S.E :: onCanvasEvent를 처리
		 */
		_setCount(numCount) {

			// [#] Text 수정
			this._restCount = this._maxCount - numCount;
			this[B_Define.TRY_COUNT_TEXT_ID]._object.text = this._restCount + '/' + this._maxCount;
			this[B_Define.TRY_COUNT_TEXT_ID]._setPoint(50,50); // [#] 글씨 중심 설정

			// [#] Canvas Event 처리
			if(this._restCount == 0) {
				// [#] state 설정
				const STATE = this.CODMOS.WORLD.STATE;
				STATE.stop(B_Define.CLEAR_STATUS['GOING'], B_Define.REASON['END']);
				// [S] boolEnd 처리 (캔버스 논리종료)
				this.CODMOS.boolEnd = true;
				this.CODMOS.onCanvasEvent(STATE.renew());
			}
		}

	}
	return B_HeaderTryCount;
}());

export default B_HeaderTryCount;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/tool/B_HeaderTryCount.js